<template>
  <div class="evaluation-scratch">
    <evaluation-content-model :id="1"></evaluation-content-model>
  </div>
</template>

<script>
import EvaluationContentModel from './components/EvaluationContentModel.vue'
export default {
  components: { EvaluationContentModel }
}
</script>

<style>

</style>